import { render, staticRenderFns } from "./DueDateWarning.vue?vue&type=template&id=295d64a1&scoped=true"
import script from "./DueDateWarning.vue?vue&type=script&lang=js"
export * from "./DueDateWarning.vue?vue&type=script&lang=js"
import style0 from "./DueDateWarning.vue?vue&type=style&index=0&id=295d64a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295d64a1",
  null
  
)

export default component.exports